import React from "react";
import { SimpleGrid } from "@chakra-ui/react";

import { Module, ModuleWithUpNext } from "@constants";
import { ModuleGridItem } from "./ModuleGridItem";

interface IModuleGrid {
  modules: (Module | ModuleWithUpNext)[];
}

function safeModuleNextStep(moduleMaybeUpNext: Module | ModuleWithUpNext) {
  if ((moduleMaybeUpNext as ModuleWithUpNext).nextStep !== undefined)
    return (moduleMaybeUpNext as ModuleWithUpNext).nextStep;
  return "";
}

/**
 * A component to display all the modules up next as interactable cards.
 * @param {ModuleWithUpNext[]} modulesUpNext the fetched modules, for a specific step.
 */
function ModuleGrid({ modules, ...delegated }: IModuleGrid) {
  return (
    <SimpleGrid columns={{ sm: 1, md: 3 }} spacing="16px" {...delegated}>
      {modules.map((moduleInGrid) => (
        <ModuleGridItem
          key={moduleInGrid.id}
          moduleName={moduleInGrid.id}
          step={safeModuleNextStep(moduleInGrid)}
          location={moduleInGrid.location}
        />
      ))}
    </SimpleGrid>
  );
}

export { ModuleGrid };
